import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import SimpleRatingBadge from '@risksmart-app/components/src/simple-rating-badge/SimpleRatingBadge';
import {
  ApprovalStatus as Approval_Status_Enum,
  type ApprovalStatus,
} from '@risksmart-app/domain/src/types/consts/approval-status';
import type { VersionStatus } from '@risksmart-app/domain/src/types/consts/version-status';
import { useMemo } from 'react';

type Props = {
  item: { Status: VersionStatus };
  changeRequests?: { ChangeRequestStatus: ApprovalStatus }[];
};

const PolicyDocumentStatusBadge = ({ item, changeRequests }: Props) => {
  const { getByValue: getDocumentFileStatus } = useRating(
    'document_file_status'
  );

  const status = useMemo(() => {
    if (
      changeRequests?.some(
        (cr) => cr.ChangeRequestStatus === Approval_Status_Enum.Pending
      )
    ) {
      return 'pending_approval';
    }

    return item.Status;
  }, [item.Status, changeRequests]);

  const rating = useMemo(
    () => getDocumentFileStatus(status),
    [status, getDocumentFileStatus]
  );

  return <SimpleRatingBadge rating={rating} />;
};

export default PolicyDocumentStatusBadge;
